/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateClientOverviewRequest
 */
export interface UpdateClientOverviewRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateClientOverviewRequest
     */
    estimatedDebt?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateClientOverviewRequest
     */
    estimatedNumberOfCreditors?: number | null;
}

/**
 * Check if a given object implements the UpdateClientOverviewRequest interface.
 */
export function instanceOfUpdateClientOverviewRequest(value: object): value is UpdateClientOverviewRequest {
    return true;
}

export function UpdateClientOverviewRequestFromJSON(json: any): UpdateClientOverviewRequest {
    return UpdateClientOverviewRequestFromJSONTyped(json, false);
}

export function UpdateClientOverviewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClientOverviewRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'estimatedDebt': json['estimatedDebt'] == null ? undefined : json['estimatedDebt'],
        'estimatedNumberOfCreditors': json['estimatedNumberOfCreditors'] == null ? undefined : json['estimatedNumberOfCreditors'],
    };
}

export function UpdateClientOverviewRequestToJSON(json: any): UpdateClientOverviewRequest {
    return UpdateClientOverviewRequestToJSONTyped(json, false);
}

export function UpdateClientOverviewRequestToJSONTyped(value?: UpdateClientOverviewRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'estimatedDebt': value['estimatedDebt'],
        'estimatedNumberOfCreditors': value['estimatedNumberOfCreditors'],
    };
}

